import WorkType from 'modules/contracts/store/models/WorkType'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class WorkTypes extends PayrollLegalEntityResource<WorkType> {
  get cacheKey(): string {
    return 'workTypes'
  }

  model() {
    return WorkType
  }
}

export { WorkTypes }
